import Backend from 'App/Dataman-Backend';

const { apiUrlProofRequests, apiUrlSuffix } = Backend.config;

export const PROOF_REQUESTS_PATHS = {
  proofRequests: apiUrlProofRequests,
  suffix: apiUrlSuffix,
};
